/* eslint-disable react-hooks/exhaustive-deps */
import useLocalStorage from 'hooks/useLocalStorageState'
import { createContext, useContext, useEffect } from 'react'

const AllHotelsToggleContext = createContext()

export const AnalyticsContextWrapper = ({ children }) => {
  const [showAllHotels, setShowAllHotels] = useLocalStorage(
    'analyticsShowAllHotels',
    false
  )
  const [showWholeGroup, setShowWholeGroup] = useLocalStorage(
    'analyticsShowWholeGroup',
    false
  )

  const [isAllTime, setIsAllTime] = useLocalStorage('analyticsIsAllTime', false)

  const [parentChain, setParentChain] = useLocalStorage('analyticsParentChain', null)

  useEffect(() => {
    const savedShowAllHotels = localStorage.getItem('analyticsShowAllHotels')

    if (savedShowAllHotels === 'true') {
      setShowAllHotels(true)
    } else {
      setShowAllHotels(false)
    }
  }, [])

  useEffect(() => {
    const savedShowWholeGroup = localStorage.getItem('analyticsShowWholeGroup')

    if (savedShowWholeGroup === 'true') {
      setShowWholeGroup(true)
    } else {
      setShowWholeGroup(false)
    }
  }, [])

  return (
    <AllHotelsToggleContext.Provider
      value={{
        showAllHotels,
        setShowAllHotels,
        showWholeGroup,
        setShowWholeGroup,
        parentChain,
        setParentChain,
        isAllTime,
        setIsAllTime
      }}
    >
      {children}
    </AllHotelsToggleContext.Provider>
  )
}

function useAllHotelsToggle() {
  const {
    showAllHotels,
    setShowAllHotels,
    showWholeGroup,
    setShowWholeGroup,
    parentChain,
    setParentChain,
    isAllTime,
    setIsAllTime
  } = useContext(AllHotelsToggleContext)

  return {
    showAllHotels,
    setShowAllHotels,
    showWholeGroup,
    setShowWholeGroup,
    parentChain,
    setParentChain,
    isAllTime,
    setIsAllTime
  }
}

export default useAllHotelsToggle
